import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import _ from 'lodash';
import { CHANGE_EVENT } from '../constants/AppConstants';
import AccountsPreferenceConstants from '../constants/AccountsPreferenceConstants';
import AccountReorderApiUtils from '../utils/AccountReorderApiUtils';

let _backPageReference = '';
let _reorderCompletePayload = '';

class AccountReorderStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getBackPageReference() {
    return _backPageReference;
  }

  setReorderCompeletePayload(data) {
    _reorderCompletePayload = data;
  }

  getPayload() {
    if (_reorderCompletePayload.length === 0) return null;
    const requestPacket = {
      accounts: [],
    };

    let batchCount = 100;
    if (_reorderCompletePayload.length < batchCount)
      batchCount = _reorderCompletePayload.length;

    let firstHalf = _.slice(_reorderCompletePayload, 0, batchCount);

    _.forEach(firstHalf, (element) => {
      requestPacket.accounts.push(element);
    });

    _reorderCompletePayload = _.slice(
      _reorderCompletePayload,
      batchCount,
      _reorderCompletePayload.length
    );

    return requestPacket;
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case AccountsPreferenceConstants.REORDER_BACKPAGE_REFERENCE:
        _backPageReference = actionData.urlString;
        break;
      case AccountsPreferenceConstants.SET_ACCOUNT_REORDER:
        this.setReorderCompeletePayload(actionData.data);
        AccountReorderApiUtils.setAccountReorderCall(this.getPayload());
        break;

      case AccountsPreferenceConstants.ACCOUNT_REORDER_BATCH_CALL: // make next batch call and udpate store for prev data
        AccountReorderApiUtils.updateAccountsStore(actionData.data);
        let payload = this.getPayload();
        payload == null
          ? AccountReorderApiUtils.udpateUI()
          : AccountReorderApiUtils.setAccountReorderCall(payload);
        break;
      default: {
        break;
      }
    }
  }
}

export default new AccountReorderStore();
